export default __webpack_public_path__ + "static/media/bbq.4bbf3efd.svg";